import script from "./HeartButton.vue?vue&type=script&setup=true&lang=js"
export * from "./HeartButton.vue?vue&type=script&setup=true&lang=js"

import "./HeartButton.vue?vue&type=style&index=0&id=201f97ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-201f97ab"]])

export default __exports__